<template>
  <div class="footer d-flex flex-column flex-sm-row fs-6 fw-bold p-5">
    <!--begin::Copyright-->
    <div class="py-5 me-2">
      <span> &copy; Hakcipta Jabatan Akauntan Negara Malaysia 2022 </span>
    </div>
    <!--end::Copyright-->

    <!--begin::Links-->
    <!-- <div class="flex-grow-1 py-5">
      <router-link
        :to="{
          name: 'privacy-policy',
        }"
      >
        Dasar Privasi
      </router-link>
      <a href="#" class="border-start px-2">Terma &amp; Syarat</a>
      <a href="#" class="border-start px-2">Hubungi Kami</a>
    </div> -->
    <!--end::Links-->
    <div class="fixed-bottom p-3 fs-8">
      {{ app_version }}
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "custom-layout-footer",
  props: {},
  components: {},
  data() {
    return {
      app_version: process.env.VUE_APP_VERSION,
    };
  },
});
</script>

<style></style>
